import React from "react";
import {
  buttonBaseClassName,
  buttonSizeClassName,
  buttonVariantClassName,
  type ButtonSize,
  type ButtonVariant,
} from "@toolkit/design";
import { cn } from "../../lib/utils";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "default", ...props }, ref) => (
    <button
      ref={ref}
      className={cn(
        "cursor-pointer",
        buttonBaseClassName,
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none",
        buttonVariantClassName[variant],
        buttonSizeClassName[size],
        className,
      )}
      {...props}
    />
  ),
);

Button.displayName = "Button";

type ButtonLinkStyleProps = {
  variant?: ButtonVariant;
  size?: ButtonSize;
};

type ButtonLinkProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  "href"
> &
  ButtonLinkStyleProps & {
    href?: string;
    to?: string;
  };

export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  (
    { className, href, to, variant = "default", size = "default", ...props },
    ref,
  ) => {
    const classes = cn(
      "cursor-pointer",
      buttonBaseClassName,
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none",
      buttonVariantClassName[variant],
      buttonSizeClassName[size],
      className,
    );

    return <a ref={ref} className={classes} href={href ?? to} {...props} />;
  },
);

ButtonLink.displayName = "ButtonLink";
